import React from 'react';

export default function ConfirmModal({ isOpen, title, summary, newBalance, actionColor = '#D44E20', confirmLabel = 'Conferma', onConfirm, onCancel, isLoading }) {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-end sm:items-center justify-center p-4" data-testid="confirm-modal">
      <div className="bg-[#18181E] rounded-t-[24px] sm:rounded-[16px] w-full max-w-sm p-6 border border-white/10 animate-fade-in">
        <h3 className="text-xl font-bold text-white mb-2">{title}</h3>
        {summary && <p className="text-[#888888] text-base mb-4">{summary}</p>}
        {newBalance !== undefined && newBalance !== null && (
          <div className="bg-[#222228] rounded-[14px] p-3 mb-4 text-center">
            <span className="text-[#888888] text-sm">Nuovo saldo: </span>
            <span className="text-white font-bold text-lg tabular-nums">{newBalance} pt</span>
          </div>
        )}
        <div className="flex gap-3 mt-2">
          <button
            data-testid="confirm-modal-cancel"
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 h-12 rounded-[14px] bg-[#222228] text-white text-base font-medium hover:bg-[#2E2E36] transition-colors disabled:opacity-50"
          >
            Annulla
          </button>
          <button
            data-testid="confirm-modal-confirm"
            onClick={onConfirm}
            disabled={isLoading}
            style={{ backgroundColor: actionColor }}
            className="flex-1 h-12 rounded-[14px] text-white text-base font-bold hover:opacity-90 active:scale-95 transition-all disabled:opacity-50"
          >
            {isLoading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                </svg>
                Attendi...
              </span>
            ) : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
